import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, CheckCircle, Lock, Phone, Clock, ShoppingBag } from 'lucide-react';
import { toast } from 'sonner';
import { createCheckout, fetchSlots, rescheduleBooking, fetchBookings } from '../../services/api';

const BookingsTab = ({
  currentFormula, isKit, kitBlocNum, currentKitData, entitlements,
  userBookings, user, selectedProgramId,
  rescheduleBookingId, setRescheduleBookingId,
  rescheduleDate, setRescheduleDate,
  rescheduleSlot, setRescheduleSlot,
  availableSlots, setAvailableSlots,
  setUserBookings, activeBookingsCount
}) => {
  return (
          <div>
            {(currentFormula === 'bronze' || isKit) ? (
              isKit ? (
              /* Kit: RDV gratuit 15 min inclus (si hasRdv) + appel payant */
              <div>
                <h2 className="heading-1" style={{ marginBottom: '2rem' }}>Mes séances</h2>

                {/* Free call card - only for kits with hasRdv */}
                {currentKitData?.hasRdv && (
                <div className="card" style={{
                  padding: '2rem', marginBottom: '2rem',
                  background: 'linear-gradient(135deg, #ECFDF5 0%, #fff 100%)',
                  border: '2px solid #10B98130'
                }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1rem' }}>
                    <div style={{
                      background: '#10B98115', borderRadius: '50%', width: '52px', height: '52px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                    }}>
                      <Phone size={24} color="#10B981" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '0.25rem' }}>1 appel de 15 minutes offert</h3>
                      <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                        Inclus avec votre Kit Bloc {kitBlocNum} — posez toutes vos questions à Rose sur votre bloc.
                      </p>
                    </div>
                  </div>

                  {userBookings.length > 0 ? (
                    /* Booking exists: show date + modify */
                    <div>
                      {userBookings.map((booking, idx) => (
                        <div key={booking.bookingId || idx} data-testid={`kit-booking-${idx}`}>
                          <div style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            background: 'white', borderRadius: '0.75rem', padding: '1rem 1.25rem',
                            border: '1px solid #10B98130', flexWrap: 'wrap', gap: '0.75rem'
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                              <CheckCircle size={20} color="#059669" />
                              <div>
                                <span style={{ fontWeight: 700, fontSize: '0.95rem', color: '#059669' }}>RDV confirmé</span>
                                <span className="body-small" style={{ display: 'block', color: 'var(--text-primary)', marginTop: '0.15rem' }}>
                                  {new Date(booking.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} à {booking.time}
                                </span>
                              </div>
                            </div>
                            <button
                              className="btn-secondary"
                              data-testid={`modify-booking-${idx}`}
                              onClick={() => {
                                if (rescheduleBookingId === booking.bookingId) {
                                  setRescheduleBookingId(null);
                                  setRescheduleDate(null);
                                  setRescheduleSlot(null);
                                } else {
                                  setRescheduleBookingId(booking.bookingId);
                                  setRescheduleDate(null);
                                  setRescheduleSlot(null);
                                  fetchSlots().then(setAvailableSlots).catch(console.error);
                                }
                              }}
                              style={{ padding: '0.4rem 1rem', fontSize: '0.8rem' }}
                            >
                              {rescheduleBookingId === booking.bookingId ? 'Annuler' : 'Modifier le RDV'}
                            </button>
                          </div>

                          {/* Reschedule form */}
                          {rescheduleBookingId === booking.bookingId && (
                            <div style={{ marginTop: '1rem', padding: '1rem', background: 'white', borderRadius: '0.75rem', border: '1px solid var(--border-light)' }}>
                              <p className="body-small" style={{ fontWeight: 600, marginBottom: '0.75rem' }}>Choisissez une nouvelle date et un horaire :</p>
                              <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                                <input
                                  type="date"
                                  data-testid="reschedule-date-input"
                                  min={new Date(Date.now() + 2 * 86400000).toISOString().split('T')[0]}
                                  value={rescheduleDate || ''}
                                  onChange={(e) => { setRescheduleDate(e.target.value); setRescheduleSlot(null); }}
                                  style={{
                                    padding: '0.6rem 1rem', borderRadius: '0.5rem',
                                    border: '2px solid var(--border-primary)', background: 'var(--bg-card)', fontSize: '0.85rem'
                                  }}
                                />
                                {rescheduleDate && (
                                  <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                                    {availableSlots.filter(s => s.date === rescheduleDate && s.available).map(slot => (
                                      <button
                                        key={slot.id}
                                        data-testid={`reschedule-slot-${slot.time}`}
                                        onClick={() => setRescheduleSlot(slot)}
                                        className={rescheduleSlot?.id === slot.id ? 'btn-primary' : 'btn-secondary'}
                                        style={{ padding: '0.4rem 0.75rem', fontSize: '0.8rem' }}
                                      >
                                        <Clock size={14} style={{ marginRight: '0.25rem' }} /> {slot.time}
                                      </button>
                                    ))}
                                    {availableSlots.filter(s => s.date === rescheduleDate && s.available).length === 0 && (
                                      <p className="body-small" style={{ color: 'var(--text-muted)' }}>Aucun créneau disponible pour cette date.</p>
                                    )}
                                  </div>
                                )}
                              </div>
                              {rescheduleSlot && (
                                <button
                                  className="btn-primary"
                                  data-testid="confirm-reschedule-btn"
                                  style={{ marginTop: '1rem', fontSize: '0.85rem' }}
                                  onClick={async () => {
                                    try {
                                      await rescheduleBooking(booking.bookingId, rescheduleDate, rescheduleSlot.time);
                                      toast.success('Rendez-vous modifié avec succès !');
                                      setRescheduleBookingId(null);
                                      setRescheduleDate(null);
                                      setRescheduleSlot(null);
                                      fetchBookings(user.id).then(setUserBookings).catch(() => {});
                                    } catch (e) {
                                      toast.error(e.message || 'Erreur lors de la modification');
                                    }
                                  }}
                                >
                                  Confirmer la modification
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    /* No booking yet: show booking button */
                    <div>
                      <div style={{
                        display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                        background: '#10B98115', padding: '0.4rem 1rem', borderRadius: '2rem',
                        color: '#059669', fontWeight: 600, fontSize: '0.8rem', marginBottom: '1.25rem'
                      }}>
                        <CheckCircle size={16} /> GRATUIT — inclus dans votre kit
                      </div>
                      <p className="body-small" style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}>
                        Choisissez la date et l'heure qui vous conviennent pour votre appel de 15 minutes avec Rose.
                      </p>
                      <Link to={`/booking?direct=true&program=${selectedProgramId}`} className="btn-primary" style={{ textDecoration: 'none' }} data-testid="kit-book-free-call">
                        Prendre rendez-vous
                      </Link>
                    </div>
                  )}
                </div>
                )}

                {/* Paid call option: 80€ / 1h usable in multiple sessions */}
                <div className="card" style={{
                  padding: '2rem', textAlign: 'center',
                  background: 'linear-gradient(135deg, #FFF7ED 0%, #fff 100%)',
                  border: '2px solid #F9731630'
                }}>
                  <div style={{
                    background: '#F9731615', borderRadius: '50%', width: '56px', height: '56px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem'
                  }}>
                    <Phone size={24} color="#F97316" />
                  </div>
                  <h3 className="heading-3" style={{ marginBottom: '0.5rem' }}>Besoin de plus de temps avec Rose ?</h3>
                  <p className="body-small" style={{ marginBottom: '1.25rem', color: 'var(--text-secondary)', maxWidth: '450px', margin: '0 auto 1.25rem' }}>
                    Réservez 1 heure d'accompagnement personnalisé, utilisable en plusieurs séances selon vos besoins.
                  </p>
                  <div style={{
                    background: 'white', borderRadius: '0.75rem', padding: '0.75rem 1.25rem',
                    display: 'inline-block', marginBottom: '1.25rem',
                    border: '1px solid #F9731630'
                  }}>
                    <span style={{ fontSize: '1.75rem', fontWeight: 800, color: '#F97316' }}>80 €</span>
                    <span className="body-small" style={{ color: 'var(--text-muted)', marginLeft: '0.5rem' }}>/ 1 heure (utilisable en plusieurs fois)</span>
                  </div>
                  <br />
                  <button
                    className="btn-primary"
                    data-testid="kit-buy-appel-btn"
                    onClick={async () => {
                      try {
                        const data = await createCheckout({
                          programId: selectedProgramId || 'deap',
                          formula: 'kit',
                          kitId: 'appel-explication',
                          kitTitle: "Appel d'explication — 1 heure",
                          price: 80,
                          origin: window.location.origin,
                          email: user.email,
                          nom: user.name?.split(' ').slice(1).join(' ') || '',
                          prenom: user.name?.split(' ')[0] || '',
                          telephone: user.phone || user.telephone || ''
                        });
                        if (data.url) window.location.href = data.url;
                      } catch (e) {
                        alert("Erreur lors de la création du paiement. Veuillez réessayer ou nous contacter.");
                      }
                    }}
                  >
                    Acheter 1 heure d'accompagnement
                  </button>
                  <p className="body-small" style={{ marginTop: '0.75rem', color: 'var(--text-muted)' }}>
                    Ou contactez-nous par <a href="https://wa.me/33688399624?text=Bonjour%20Rose%2C%20je%20souhaite%20r%C3%A9server%20un%20appel%20d%27explication%20pour%20mon%20dossier%20VAE." target="_blank" rel="noopener noreferrer" style={{ color: '#25D366', fontWeight: 600 }}>WhatsApp</a> ou au <a href="tel:+33688399624" style={{ color: '#E75480', fontWeight: 600 }}>06 88 39 96 24</a>
                  </p>
                </div>
              </div>
              ) : (
              /* Bronze: affichage des RDV + propose d'acheter un appel */
              <div>
                <h2 className="heading-1" style={{ marginBottom: '2rem' }}>Mes séances</h2>

                {/* Existing bookings */}
                {userBookings.length > 0 && (
                  <div style={{ marginBottom: '2rem' }}>
                    <h3 className="heading-3" style={{ marginBottom: '1rem' }}>Mes rendez-vous</h3>
                    {userBookings.map((booking, idx) => (
                      <div key={booking.bookingId || idx} className="card" style={{ marginBottom: '0.75rem', padding: '1.25rem' }} data-testid={`bronze-booking-${idx}`}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Calendar size={18} style={{ color: 'var(--accent-primary)' }} />
                            <div>
                              <span className="body-small" style={{ fontWeight: 600 }}>
                                {new Date(booking.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
                              </span>
                              <span className="body-small" style={{ color: 'var(--text-secondary)', marginLeft: '0.5rem' }}>
                                à {booking.time}
                              </span>
                            </div>
                          </div>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <span style={{
                              background: booking.status === 'confirmed' ? '#ECFDF5' : '#FFF7ED',
                              color: booking.status === 'confirmed' ? '#059669' : '#D97706',
                              padding: '0.25rem 0.75rem', borderRadius: '1rem',
                              fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase'
                            }}>
                              {booking.status === 'confirmed' ? 'Confirmé' : booking.status}
                            </span>
                            <button
                              className="btn-secondary"
                              data-testid={`modify-bronze-booking-${idx}`}
                              onClick={() => {
                                if (rescheduleBookingId === booking.bookingId) {
                                  setRescheduleBookingId(null);
                                  setRescheduleDate(null);
                                  setRescheduleSlot(null);
                                } else {
                                  setRescheduleBookingId(booking.bookingId);
                                  setRescheduleDate(null);
                                  setRescheduleSlot(null);
                                  fetchSlots().then(setAvailableSlots).catch(console.error);
                                }
                              }}
                              style={{ padding: '0.3rem 0.75rem', fontSize: '0.75rem' }}
                            >
                              {rescheduleBookingId === booking.bookingId ? 'Annuler' : 'Modifier'}
                            </button>
                          </div>
                        </div>

                        {/* Reschedule form */}
                        {rescheduleBookingId === booking.bookingId && (
                          <div style={{ marginTop: '1.25rem', paddingTop: '1.25rem', borderTop: '1px solid var(--border-light)' }}>
                            <p className="body-small" style={{ fontWeight: 600, marginBottom: '0.75rem' }}>Choisissez une nouvelle date et un horaire :</p>
                            <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                              <input
                                type="date"
                                data-testid="reschedule-date-input-bronze"
                                min={new Date(Date.now() + 2 * 86400000).toISOString().split('T')[0]}
                                value={rescheduleDate || ''}
                                onChange={(e) => { setRescheduleDate(e.target.value); setRescheduleSlot(null); }}
                                style={{
                                  padding: '0.6rem 1rem', borderRadius: '0.5rem',
                                  border: '2px solid var(--border-primary)', background: 'var(--bg-card)', fontSize: '0.85rem'
                                }}
                              />
                              {rescheduleDate && (
                                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                                  {availableSlots.filter(s => s.date === rescheduleDate && s.available).map(slot => (
                                    <button
                                      key={slot.id}
                                      onClick={() => setRescheduleSlot(slot)}
                                      className={rescheduleSlot?.id === slot.id ? 'btn-primary' : 'btn-secondary'}
                                      style={{ padding: '0.4rem 0.75rem', fontSize: '0.8rem' }}
                                    >
                                      <Clock size={14} style={{ marginRight: '0.25rem' }} /> {slot.time}
                                    </button>
                                  ))}
                                  {availableSlots.filter(s => s.date === rescheduleDate && s.available).length === 0 && (
                                    <p className="body-small" style={{ color: 'var(--text-muted)' }}>Aucun créneau disponible.</p>
                                  )}
                                </div>
                              )}
                            </div>
                            {rescheduleSlot && (
                              <button
                                className="btn-primary"
                                data-testid="confirm-reschedule-bronze-btn"
                                style={{ marginTop: '1rem', fontSize: '0.85rem' }}
                                onClick={async () => {
                                  try {
                                    await rescheduleBooking(booking.bookingId, rescheduleDate, rescheduleSlot.time);
                                    toast.success('Rendez-vous modifié avec succès !');
                                    setRescheduleBookingId(null);
                                    setRescheduleDate(null);
                                    setRescheduleSlot(null);
                                    fetchBookings(user.id).then(setUserBookings).catch(() => {});
                                  } catch (e) {
                                    toast.error(e.message || 'Erreur lors de la modification');
                                  }
                                }}
                              >
                                Confirmer la modification
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Paid call offer */}
                <div className="card" style={{
                  padding: '2.5rem', textAlign: 'center',
                  background: 'linear-gradient(135deg, #FFF7ED 0%, #fff 100%)',
                  border: '2px solid #F9731630'
                }}>
                  <div style={{
                    background: '#F9731615', borderRadius: '50%', width: '64px', height: '64px',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1.25rem'
                  }}>
                    <Phone size={28} color="#F97316" />
                  </div>
                  <h3 className="heading-2" style={{ marginBottom: '0.75rem' }}>Besoin d'aide sur votre Livret 2 ?</h3>
                  <p className="body-medium" style={{ marginBottom: '1.5rem', color: 'var(--text-secondary)', maxWidth: '500px', margin: '0 auto 1.5rem' }}>
                    Réservez un appel d'explication avec Rose pour répondre à toutes vos questions sur votre dossier VAE.
                  </p>
                  <div style={{
                    background: 'white', borderRadius: '0.75rem', padding: '1rem 1.5rem',
                    display: 'inline-block', marginBottom: '1.5rem',
                    border: '1px solid #F9731630'
                  }}>
                    <span style={{ fontSize: '2rem', fontWeight: 800, color: '#F97316' }}>80 €</span>
                    <span className="body-small" style={{ color: 'var(--text-muted)', marginLeft: '0.5rem' }}>/ 1 heure (utilisable en plusieurs fois)</span>
                  </div>
                  <br />
                  <button
                    className="btn-primary"
                    data-testid="buy-appel-btn"
                    onClick={async () => {
                      try {
                        const data = await createCheckout({
                          programId: selectedProgramId || 'deap',
                          formula: 'kit',
                          kitId: 'appel-explication',
                          kitTitle: "Appel d'explication",
                          price: 80,
                          origin: window.location.origin,
                          email: user.email,
                          nom: user.name?.split(' ').slice(1).join(' ') || '',
                          prenom: user.name?.split(' ')[0] || '',
                          telephone: user.phone || user.telephone || ''
                        });
                        if (data.url) window.location.href = data.url;
                      } catch (e) {
                        alert("Erreur lors de la création du paiement. Veuillez réessayer ou nous contacter.");
                      }
                    }}
                  >
                    Payer et réserver un appel
                  </button>
                  <p className="body-small" style={{ marginTop: '1rem', color: 'var(--text-muted)' }}>
                    Ou contactez-nous par <a href="https://wa.me/33688399624?text=Bonjour%20Rose%2C%20je%20souhaite%20r%C3%A9server%20un%20appel%20d%27explication%20pour%20mon%20dossier%20VAE." target="_blank" rel="noopener noreferrer" style={{ color: '#25D366', fontWeight: 600 }}>WhatsApp</a> ou au <a href="tel:+33688399624" style={{ color: '#E75480', fontWeight: 600 }}>06 88 39 96 24</a>
                  </p>
                </div>
              </div>
            )) : (
              /* Silver/Gold: séances d'accompagnement */
              <div>
                <h2 className="heading-1" style={{ marginBottom: '2rem' }}>Mes séances</h2>

                {/* Coaching entitlement card */}
                <div className="card" style={{
                  padding: '2rem', marginBottom: '2rem',
                  background: 'linear-gradient(135deg, #EDE9FE 0%, #fff 100%)',
                  border: '2px solid #8B5CF630'
                }}>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', marginBottom: '1rem' }}>
                    <div style={{
                      background: '#8B5CF615', borderRadius: '50%', width: '52px', height: '52px',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0
                    }}>
                      <Phone size={24} color="#8B5CF6" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <h3 style={{ fontWeight: 700, fontSize: '1rem', marginBottom: '0.25rem' }}>
                        Vos séances d'accompagnement
                      </h3>
                      <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                        {currentFormula === 'gold' 
                          ? 'Accompagnement illimité pendant 1 an — profitez de séances avec Rose autant que nécessaire.'
                          : `${entitlements.seances} séances de coaching incluses dans votre formule Silver.`
                        }
                      </p>
                    </div>
                  </div>
                  {currentFormula === 'silver' && (
                    <div style={{ marginBottom: '0.75rem' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.35rem' }}>
                        <span className="caption" style={{ fontWeight: 600 }}>Séances utilisées</span>
                        <span className="caption" style={{ fontWeight: 700, color: activeBookingsCount >= entitlements.seances ? '#EF4444' : '#7C3AED' }}>{Math.min(activeBookingsCount, entitlements.seances)}/{entitlements.seances}</span>
                      </div>
                      <div style={{ width: '100%', height: '8px', background: '#E5E7EB', borderRadius: '4px', overflow: 'hidden' }}>
                        <div style={{ width: `${Math.min((activeBookingsCount / entitlements.seances) * 100, 100)}%`, height: '100%', background: activeBookingsCount >= entitlements.seances ? '#EF4444' : '#8B5CF6', borderRadius: '4px', transition: 'width 0.5s ease' }} />
                      </div>
                    </div>
                  )}
                  <div style={{
                    display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                    background: '#8B5CF615', padding: '0.4rem 1rem', borderRadius: '2rem',
                    color: '#7C3AED', fontWeight: 600, fontSize: '0.8rem'
                  }}>
                    <CheckCircle size={16} /> 
                    {currentFormula === 'gold' ? 'Illimité — Formule Or' : `${entitlements.seances} séances — Formule Argent`}
                  </div>
                </div>

                {/* RDV Découverte section - shown separately */}
                {userBookings.filter(b => b.type === 'decouverte').length > 0 && (
                  <div style={{ marginBottom: '2rem' }}>
                    <h3 className="heading-3" style={{ marginBottom: '1rem', color: '#6B7280' }}>RDV Découverte</h3>
                    {userBookings.filter(b => b.type === 'decouverte').map((booking, idx) => (
                      <div key={booking.bookingId || `dec-${idx}`} className="card" style={{
                        marginBottom: '0.5rem', padding: '1rem 1.25rem',
                        background: '#FFFBEB', border: '1px solid #FDE68A'
                      }} data-testid={`decouverte-booking-${idx}`}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', justifyContent: 'space-between', flexWrap: 'wrap' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <Calendar size={18} color="#D97706" />
                            <div>
                              <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#92400E' }}>
                                RDV Découverte
                              </span>
                              <span className="body-small" style={{ display: 'block', color: '#78350F', marginTop: '0.15rem' }}>
                                {new Date(booking.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} {booking.time ? `à ${booking.time}` : ''}
                              </span>
                            </div>
                          </div>
                          <span style={{
                            background: '#FEF3C7', color: '#92400E',
                            padding: '0.25rem 0.75rem', borderRadius: '1rem',
                            fontSize: '0.7rem', fontWeight: 600
                          }}>
                            Gratuit
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Existing bookings (formule only) - split into upcoming and past */}
                {userBookings.filter(b => b.type !== 'decouverte').length > 0 ? (
                  <div style={{ marginBottom: '2rem' }}>
                    {/* Upcoming bookings */}
                    {userBookings.filter(b => b.type !== 'decouverte' && new Date(b.date) >= new Date(new Date().toDateString())).length > 0 && (
                      <>
                        <h3 className="heading-3" style={{ marginBottom: '1rem' }}>Prochains rendez-vous</h3>
                        {userBookings.filter(b => b.type !== 'decouverte' && new Date(b.date) >= new Date(new Date().toDateString())).map((booking, idx) => (
                      <div key={booking.bookingId || idx} className="card" style={{ marginBottom: '0.75rem', padding: '1.25rem' }} data-testid={`sg-booking-${idx}`}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                            <CheckCircle size={20} color={booking.status === 'confirmed' ? '#059669' : '#D97706'} />
                            <div>
                              <span style={{ fontWeight: 700, fontSize: '0.95rem', color: booking.status === 'confirmed' ? '#059669' : '#D97706' }}>
                                {booking.status === 'confirmed' ? 'RDV confirmé' : 'En attente'}
                              </span>
                              <span className="body-small" style={{ display: 'block', color: 'var(--text-primary)', marginTop: '0.15rem' }}>
                                {new Date(booking.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} à {booking.time}
                              </span>
                            </div>
                          </div>
                          <button
                            className="btn-secondary"
                            data-testid={`modify-sg-booking-${idx}`}
                            onClick={() => {
                              if (rescheduleBookingId === booking.bookingId) {
                                setRescheduleBookingId(null);
                                setRescheduleDate(null);
                                setRescheduleSlot(null);
                              } else {
                                setRescheduleBookingId(booking.bookingId);
                                setRescheduleDate(null);
                                setRescheduleSlot(null);
                                fetchSlots().then(setAvailableSlots).catch(console.error);
                              }
                            }}
                            style={{ padding: '0.4rem 1rem', fontSize: '0.8rem' }}
                          >
                            {rescheduleBookingId === booking.bookingId ? 'Annuler' : 'Modifier le RDV'}
                          </button>
                        </div>

                        {/* Reschedule form */}
                        {rescheduleBookingId === booking.bookingId && (
                          <div style={{ marginTop: '1rem', padding: '1rem', background: 'var(--bg-section)', borderRadius: '0.75rem' }}>
                            <p className="body-small" style={{ fontWeight: 600, marginBottom: '0.75rem' }}>Choisissez une nouvelle date et un horaire :</p>
                            <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap', alignItems: 'flex-start' }}>
                              <input
                                type="date"
                                data-testid="reschedule-date-input-sg"
                                min={new Date(Date.now() + 2 * 86400000).toISOString().split('T')[0]}
                                value={rescheduleDate || ''}
                                onChange={(e) => { setRescheduleDate(e.target.value); setRescheduleSlot(null); }}
                                style={{
                                  padding: '0.6rem 1rem', borderRadius: '0.5rem',
                                  border: '2px solid var(--border-primary)', background: 'var(--bg-card)', fontSize: '0.85rem'
                                }}
                              />
                              {rescheduleDate && (
                                <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                                  {availableSlots.filter(s => s.date === rescheduleDate && s.available).map(slot => (
                                    <button
                                      key={slot.id}
                                      onClick={() => setRescheduleSlot(slot)}
                                      className={rescheduleSlot?.id === slot.id ? 'btn-primary' : 'btn-secondary'}
                                      style={{ padding: '0.4rem 0.75rem', fontSize: '0.8rem' }}
                                    >
                                      <Clock size={14} style={{ marginRight: '0.25rem' }} /> {slot.time}
                                    </button>
                                  ))}
                                  {availableSlots.filter(s => s.date === rescheduleDate && s.available).length === 0 && (
                                    <p className="body-small" style={{ color: 'var(--text-muted)' }}>Aucun créneau disponible.</p>
                                  )}
                                </div>
                              )}
                            </div>
                            {rescheduleSlot && (
                              <button
                                className="btn-primary"
                                data-testid="confirm-reschedule-sg-btn"
                                style={{ marginTop: '1rem', fontSize: '0.85rem' }}
                                onClick={async () => {
                                  try {
                                    await rescheduleBooking(booking.bookingId, rescheduleDate, rescheduleSlot.time);
                                    toast.success('Rendez-vous modifié avec succès !');
                                    setRescheduleBookingId(null);
                                    setRescheduleDate(null);
                                    setRescheduleSlot(null);
                                    fetchBookings(user.id).then(setUserBookings).catch(() => {});
                                  } catch (e) {
                                    toast.error(e.message || 'Erreur lors de la modification');
                                  }
                                }}
                              >
                                Confirmer la modification
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                        ))}
                      </>
                    )}

                    {/* Past bookings */}
                    {userBookings.filter(b => b.type !== 'decouverte' && new Date(b.date) < new Date(new Date().toDateString())).length > 0 && (
                      <div style={{ marginTop: '2rem' }}>
                        <h3 className="heading-3" style={{ marginBottom: '1rem', color: '#6B7280' }}>Historique des séances passées</h3>
                        {userBookings.filter(b => b.type !== 'decouverte' && new Date(b.date) < new Date(new Date().toDateString())).map((booking, idx) => (
                          <div key={booking.bookingId || `past-${idx}`} className="card" style={{
                            marginBottom: '0.5rem', padding: '1rem 1.25rem',
                            opacity: 0.7, background: '#f9fafb'
                          }} data-testid={`past-booking-${idx}`}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                              <CheckCircle size={18} color="#9CA3AF" />
                              <div>
                                <span style={{ fontWeight: 600, fontSize: '0.9rem', color: '#374151' }}>Séance effectuée</span>
                                <span className="body-small" style={{ display: 'block', color: '#6B7280', marginTop: '0.1rem' }}>
                                  {new Date(booking.date).toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })} à {booking.time}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="card" style={{ padding: '1.5rem', marginBottom: '2rem', textAlign: 'center' }}>
                    <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '1rem' }}>
                      Vous n'avez pas encore de rendez-vous planifié. Réservez votre première séance avec Rose.
                    </p>
                  </div>
                )}

                {/* Book new session */}
                <div style={{ textAlign: 'center' }}>
                  {currentFormula === 'silver' && activeBookingsCount >= entitlements.seances ? (
                    <div className="card" style={{ padding: '1.5rem', background: '#FEF2F2', border: '2px solid #FECACA' }}>
                      <p className="body-small" style={{ fontWeight: 600, color: '#991B1B', marginBottom: '0.75rem' }}>
                        Vous avez utilisé vos {entitlements.seances} séances incluses dans la formule Silver.
                      </p>
                      <p className="body-small" style={{ color: '#7F1D1D', marginBottom: '1rem' }}>
                        Pour bénéficier de séances supplémentaires, vous pouvez acheter un appel d'explication.
                      </p>
                      <button
                        className="btn-primary"
                        data-testid="sg-buy-extra-session"
                        onClick={async () => {
                          try {
                            const data = await createCheckout({
                              programId: selectedProgramId,
                              formula: 'kit',
                              kitId: 'appel-explication',
                              kitTitle: "Appel d'explication — 1 heure",
                              price: 80,
                              origin: window.location.origin,
                              email: user.email,
                          nom: user.name?.split(' ').slice(1).join(' ') || '',
                          prenom: user.name?.split(' ')[0] || '',
                          telephone: user.phone || user.telephone || ''
                            });
                            if (data.url) window.location.href = data.url;
                          } catch (e) {
                            alert("Erreur lors de la création du paiement. Veuillez réessayer ou nous contacter.");
                          }
                        }}
                      >
                        Acheter une séance supplémentaire (80€)
                      </button>
                    </div>
                  ) : (
                    <Link to={`/booking?direct=true&program=${selectedProgramId}&formula=${currentFormula}`} className="btn-primary" style={{ textDecoration: 'none', display: 'inline-block' }} data-testid="sg-book-session">
                      Réserver une séance
                    </Link>
                  )}
                </div>
              </div>
            )}
          </div>

  );
};

export default BookingsTab;
